{
  "version": "1.2.6",
  "objects": {
    "7431911414822695549": {
      "type": "frame",
      "id": "7431911414822695549",
      "z": 7236,
      "textContent": "",
      "left": 5450.7522425676,
      "top": 359.2446611448529,
      "width": 400,
      "height": 500,
      "scaleX": 2.6367746204485503,
      "scaleY": 0.706,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 30,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7431911414816476214": {
      "type": "frame",
      "id": "7431911414816476214",
      "z": 6838,
      "textContent": "Frame 121",
      "left": 5480.7522425676,
      "top": 389.2446611448529,
      "width": 400,
      "height": 500,
      "scaleX": 2.4867746204485504,
      "scaleY": 0.124,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7431911414822695549",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7431911414823273884": {
      "type": "shape",
      "id": "7431911414823273884",
      "z": 6839,
      "shapeName": "text",
      "textContent": "<p><strong>Table name</strong></p>",
      "left": 5480.7522425676,
      "top": 399.2446611448529,
      "width": 86.1,
      "height": 29.4,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.4285714285714286,
      "scaleY": 1.4285714285714286,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 20,
      "angle": 0,
      "container": "7431911414816476214",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false
    },
    "7431911414816899135": {
      "type": "shape",
      "id": "7431911414816899135",
      "z": 6841,
      "shapeName": "text",
      "textContent": "<p>Date: MM/DD/YYYY</p>",
      "left": 6320.46209074702,
      "top": 403.2446611448529,
      "width": 135.625,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7431911414816476214",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7431911414813007713": {
      "type": "table",
      "id": "7431911414813007713",
      "z": 6840,
      "textContent": "",
      "left": 5485.932218337597,
      "top": 481.2446611448529,
      "width": 983.3498966394251,
      "height": 200,
      "scaleX": 1,
      "scaleY": 1,
      "fill": "#FFFFFF",
      "stroke": "#CACACA",
      "strokeWidth": 1,
      "opacity": 1,
      "borderOpacity": 1,
      "container": "7431911414822695549",
      "layoutPosition": "a3",
      "numColumns": 7,
      "numRows": 4,
      "col_0_width": 215.49188183764625,
      "col_1_width": 133.8411319250871,
      "col_2_width": 129.2186789862966,
      "col_3_width": 124.3880741643801,
      "col_4_width": 126.80337657533835,
      "col_5_width": 126.80337657533835,
      "col_6_width": 126.80337657533835,
      "row_0_height": 50,
      "row_1_height": 50,
      "row_2_height": 50,
      "row_3_height": 50,
      "row_4_height": null,
      "row_5_height": null,
      "row_6_height": null,
      "row_7_height": null,
      "row_8_height": null,
      "row_9_height": null,
      "row_10_height": null,
      "cell_0_0_fill": "#DAD7FF",
      "cell_0_1_fill": "#FFFFFF",
      "cell_0_2_fill": "#FFFFFF",
      "cell_0_3_fill": "#FFFFFF",
      "cell_1_0_fill": "#DAD7FF",
      "cell_2_0_fill": "#DAD7FF",
      "cell_3_0_fill": "#DAD7FF",
      "cell_0_0_opacity": 0.3,
      "cell_0_1_opacity": 1,
      "cell_0_2_opacity": 1,
      "cell_0_3_opacity": 1,
      "cell_1_0_opacity": 0.3,
      "cell_2_0_opacity": 0.4,
      "cell_3_0_opacity": 0.4,
      "textFields": {
        "cell_0_0": {
          "fontSize": 18,
          "textAlign": "left",
          "textContent": "<p><strong>Row name 1</strong></p>",
          "textOpacity": 1,
          "verticalAlign": "flex-start"
        },
        "cell_0_1": {
          "fontSize": 18,
          "textAlign": "left",
          "textOpacity": 1,
          "verticalAlign": "flex-start"
        },
        "cell_0_2": {
          "fontSize": 18,
          "textAlign": "left",
          "textOpacity": 1,
          "verticalAlign": "flex-start"
        },
        "cell_0_3": {
          "fontSize": 18,
          "textAlign": "left",
          "textOpacity": 1,
          "verticalAlign": "flex-start"
        },
        "cell_1_0": {
          "fontSize": 18,
          "textAlign": "left",
          "textContent": "<p><strong>Row name 2</strong></p>",
          "textOpacity": 1,
          "verticalAlign": "flex-start"
        },
        "cell_2_0": {
          "fontSize": 18,
          "textAlign": "left",
          "textContent": "<p><strong>Row name 3</strong></p>",
          "textOpacity": 1,
          "verticalAlign": "flex-start"
        },
        "cell_3_0": {
          "fontSize": 18,
          "textAlign": "left",
          "textContent": "<p><strong>Row name 4</strong></p>",
          "textOpacity": 1,
          "verticalAlign": "flex-start"
        },
        "cell_4_0": null,
        "cell_4_1": null,
        "cell_4_2": null,
        "cell_4_3": null,
        "cell_4_4": null,
        "cell_4_5": null,
        "cell_4_6": null,
        "cell_5_0": null,
        "cell_5_1": null,
        "cell_5_2": null,
        "cell_5_3": null,
        "cell_5_4": null,
        "cell_5_5": null,
        "cell_5_6": null,
        "cell_6_0": null,
        "cell_6_1": null,
        "cell_6_2": null,
        "cell_6_3": null,
        "cell_6_4": null,
        "cell_6_5": null,
        "cell_6_6": null,
        "cell_7_0": null,
        "cell_7_1": null,
        "cell_7_2": null,
        "cell_7_3": null,
        "cell_7_4": null,
        "cell_7_5": null,
        "cell_7_6": null,
        "cell_8_0": null,
        "cell_8_1": null,
        "cell_8_2": null,
        "cell_8_3": null,
        "cell_8_4": null,
        "cell_8_5": null,
        "cell_8_6": null,
        "cell_9_0": null,
        "cell_9_1": null,
        "cell_9_2": null,
        "cell_9_3": null,
        "cell_9_4": null,
        "cell_9_5": null,
        "cell_9_6": null,
        "cell_10_0": null,
        "cell_10_1": null,
        "cell_10_2": null,
        "cell_10_3": null,
        "cell_10_4": null,
        "cell_10_5": null,
        "cell_10_6": null
      }
    }
  }
}
